module.exports = __webpack_public_path__ + "img/c4.2085887a.png";